export default {
  tiles: [
    {
      id: 1,
      employeeImageUrl:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-amrita-desktop.jpg',
      employeeImageUrlMobile:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-amrita-desktop.jpg',
      employeeName: 'Amrita Jayakumar',
      employeeTitle: 'Content Nerd',
      employeeDescription:
        "Everyone can benefit from learning how to use money effectively to accomplish goals. We're changing the perception that knowing how to manage your money is only for the wealthy.",
    },
    {
      id: 2,
      employeeImageUrl:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-andrew-desktop.jpg',
      employeeImageUrlMobile:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-andrew-mobile.jpg',
      employeeName: 'Andrew Hollenbach',
      employeeTitle: 'Engineering Nerd',
      employeeDescription:
        'I love the constant feedback we receive from users about how we have positively impacted their lives.',
    },
    {
      id: 3,
      employeeImageUrl:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-gianna-desktop.jpg',
      employeeImageUrlMobile:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-gianna-mobile.jpg',
      employeeName: 'Gianna Sen - Gupta',
      employeeTitle: 'Product Nerd',
      employeeDescription:
        "What motivates me most is feeling that my work has an impact, and that I can see how that impact directly shapes peoples' lives.",
    },
    {
      id: 4,
      employeeImageUrl:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-andrea-desktop.jpg',
      employeeImageUrlMobile:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-andrea-mobile.jpg',
      employeeName: 'Andrea Coombes',
      employeeTitle: 'Content Nerd',
      employeeDescription:
        "I'm always struck by how smart, driven and ethical my colleagues are. Our guiding star is, first and foremost, helping consumers make smart money decisions.",
    },
    {
      id: 5,
      employeeImageUrl:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-vivian-desktop.jpg',
      employeeImageUrlMobile:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-vivian-mobile.jpg',
      employeeName: 'Vivian Chan',
      employeeTitle: 'Engineering Nerd',
      employeeDescription:
        'Working at NerdWallet helps me continuously grow both my technical skills and personal financial knowledge.',
    },
    {
      id: 6,
      employeeImageUrl:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-mickey-desktop.jpg',
      employeeImageUrlMobile:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-mickey-mobile.jpg',
      employeeName: 'Mickey Kay',
      employeeTitle: 'Engineering Nerd',
      employeeDescription:
        'I take pride knowing that our entire strategy is based on a core mission of service.',
    },
    {
      id: 7,
      employeeImageUrl:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-maria-desktop.jpg',
      employeeImageUrlMobile:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-maria-mobile.jpg',
      employeeName: 'Maria Can',
      employeeTitle: 'Engineering Nerd',
      employeeDescription:
        'I enjoy coming to work and feeling challenged and pushed to grow in my career — while also bettering the lives of individuals.',
    },
    {
      id: 8,
      employeeImageUrl:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-braxton-desktop.jpg',
      employeeImageUrlMobile:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-braxton-mobile.jpg',
      employeeName: 'Braxton Gunter',
      employeeTitle: 'Engineering Nerd',
      employeeDescription:
        "In my time at NerdWallet, the word 'nerd' has come to be synonymous with 'passionate.' That passion manifests in the product, and also in the relationships formed here.",
    },
    {
      id: 9,
      employeeImageUrl:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-kristyn-desktop.jpg',
      employeeImageUrlMobile:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-kristyn-mobile.jpg',
      employeeName: 'Kristyn Braden',
      employeeTitle: 'Design Nerd',
      employeeDescription:
        "At NerdWallet, you're not just a number. You have the opportunity to make a big impact and receive tons of support from your peers.",
    },
    {
      id: 10,
      employeeImageUrl:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/desktop/testimonials-nicole-desktop.jpg',
      employeeImageUrlMobile:
        'https://www.nerdwallet.com/cdn/company/images/testimonials/v2/mobile/testimonials-nicole-mobile.jpg',
      employeeName: 'Nicole Varvitsiotes',
      employeeTitle: 'Design Nerd',
      employeeDescription:
        'Our team is extremely thoughtful about the words we place on the page because, well, words matter. They’re there to clarify, encourage, debunk, and congratulate because everyone deserves to succeed at making the most of their money and their life.',
    },
  ],
};
